function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"])
    return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r))
    return _arrayLikeToArray(r); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
import { Close as CloseIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { Alert, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, InputAdornment, TextField, Typography } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { UserAPI } from '../apis/UserAPI';
import { constants } from '../constants';
// Helper function to get email input end adornment
var getEmailEndAdornment = function getEmailEndAdornment(currentUser, userIndex, updateUserField, clearEmailValidation) {
    if (currentUser.isValidatingEmail) {
        return /*#__PURE__*/ React.createElement(InputAdornment, {
            position: "end"
        }, /*#__PURE__*/ React.createElement(CircularProgress, {
            size: 20
        }));
    }
    if (currentUser.email) {
        return /*#__PURE__*/ React.createElement(InputAdornment, {
            position: "end"
        }, /*#__PURE__*/ React.createElement(CloseIcon, {
            sx: {
                color: '#595959',
                fontSize: 20,
                cursor: 'pointer'
            },
            onClick: function onClick() {
                updateUserField(userIndex, 'email', '');
                clearEmailValidation(userIndex);
            }
        }));
    }
    return null;
};
// Helper function to clear email validation for a user
var clearEmailValidationHelper = function clearEmailValidationHelper(userIndex, setUsers) {
    setUsers(function (prev) {
        return prev.map(function (user, index) {
            return index === userIndex ? _objectSpread(_objectSpread({}, user), {}, {
                emailValidationError: null,
                namesFromAPI: false
            }) : user;
        });
    });
};
var AddUserModal = function AddUserModal(_ref) {
    var open = _ref.open, onClose = _ref.onClose, onSave = _ref.onSave, user = _ref.user, loading = _ref.loading, saveError = _ref.saveError;
    var _useState = useState([{
            id: Date.now(),
            email: '',
            firstName: '',
            lastName: '',
            phoneNumber: '',
            namesFromAPI: false,
            isValidatingEmail: false,
            emailValidationError: null
        }]), _useState2 = _slicedToArray(_useState, 2), users = _useState2[0], setUsers = _useState2[1];
    var _useState3 = useState(new Map()), _useState4 = _slicedToArray(_useState3, 2), validatedEmails = _useState4[0], setValidatedEmails = _useState4[1];
    // Function to validate email using UserAPI
    var validateEmailWithAPI = useCallback(/*#__PURE__*/ function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee(email, userIndex) {
            var cachedUserInfo, validationResult, _validationResult$err, _t;
            return _regenerator().w(function (_context) {
                while (1)
                    switch (_context.p = _context.n) {
                        case 0:
                            _context.p = 0;
                            setUsers(function (prev) {
                                return prev.map(function (user, index) {
                                    return index === userIndex ? _objectSpread(_objectSpread({}, user), {}, {
                                        isValidatingEmail: true,
                                        emailValidationError: null
                                    }) : user;
                                });
                            });
                            // Check if already validated and return cached user info
                            if (!validatedEmails.has(email.toLowerCase())) {
                                _context.n = 1;
                                break;
                            }
                            cachedUserInfo = validatedEmails.get(email.toLowerCase());
                            return _context.a(2, {
                                isValid: true,
                                userInfo: cachedUserInfo
                            });
                        case 1:
                            _context.n = 2;
                            return UserAPI.validateEmail(email);
                        case 2:
                            validationResult = _context.v;
                            if (!(validationResult.isValid && validationResult.userInfo)) {
                                _context.n = 3;
                                break;
                            }
                            // Cache the validated email with user info
                            setValidatedEmails(function (prev) {
                                var newMap = new Map(prev);
                                newMap.set(email.toLowerCase(), validationResult.userInfo);
                                return newMap;
                            });
                            return _context.a(2, {
                                isValid: true,
                                userInfo: validationResult.userInfo
                            });
                        case 3:
                            return _context.a(2, {
                                isValid: false,
                                error: (_validationResult$err = validationResult.error) !== null && _validationResult$err !== void 0 ? _validationResult$err : constants.add_user_modal_email_validation_failed
                            });
                        case 4:
                            _context.n = 6;
                            break;
                        case 5:
                            _context.p = 5;
                            _t = _context.v;
                            console.error('Email validation error:', _t);
                            return _context.a(2, {
                                isValid: false,
                                error: constants.add_user_modal_email_validate_failed
                            });
                        case 6:
                            _context.p = 6;
                            setUsers(function (prev) {
                                return prev.map(function (user, index) {
                                    return index === userIndex ? _objectSpread(_objectSpread({}, user), {}, {
                                        isValidatingEmail: false
                                    }) : user;
                                });
                            });
                            return _context.f(6);
                        case 7:
                            return _context.a(2);
                    }
            }, _callee, null, [[0, 5, 6, 7]]);
        }));
        return function (_x, _x2) {
            return _ref2.apply(this, arguments);
        };
    }(), [validatedEmails]);
    useEffect(function () {
        if (user) {
            setUsers([{
                    id: Date.now(),
                    email: user.email,
                    firstName: user.name.split(' ')[0] || '',
                    lastName: user.name.split(' ').slice(1).join(' ') || '',
                    phoneNumber: user.phone || '',
                    namesFromAPI: false,
                    isValidatingEmail: false,
                    emailValidationError: null
                }]);
        }
        else {
            setUsers([{
                    id: Date.now(),
                    email: '',
                    firstName: '',
                    lastName: '',
                    phoneNumber: '',
                    namesFromAPI: false,
                    isValidatingEmail: false,
                    emailValidationError: null
                }]);
        }
        if (open) {
            setValidatedEmails(new Map());
        }
    }, [user, open]);
    // Helper function to parse user name from API response
    var parseUserName = function parseUserName(fullName) {
        var firstName = '';
        var lastName = '';
        if (fullName.includes(',')) {
            var _nameParts$, _nameParts$2;
            var nameParts = fullName.split(',').map(function (part) {
                return part.trim();
            });
            lastName = (_nameParts$ = nameParts[0]) !== null && _nameParts$ !== void 0 ? _nameParts$ : '';
            firstName = (_nameParts$2 = nameParts[1]) !== null && _nameParts$2 !== void 0 ? _nameParts$2 : '';
        }
        else {
            var _nameParts$3;
            // Fallback: treat as "First Last" format
            var _nameParts = fullName.split(' ');
            firstName = (_nameParts$3 = _nameParts[0]) !== null && _nameParts$3 !== void 0 ? _nameParts$3 : '';
            lastName = _nameParts.slice(1).join(' ') || '';
        }
        return {
            firstName: firstName,
            lastName: lastName
        };
    };
    // Helper function to check if email should be validated via API
    var shouldValidateViaAPI = function shouldValidateViaAPI(userEmail) {
        var _process$env$REACT_AP, _process$env$REACT_AP2;
        var isApprovedEmail = userEmail.toLowerCase().endsWith("@".concat((_process$env$REACT_AP = process.env.REACT_APP_USER_LOOKUP_EMAIL_DOMAIN) !== null && _process$env$REACT_AP !== void 0 ? _process$env$REACT_AP : ''));
        var isApiEnabled = JSON.parse((_process$env$REACT_AP2 = process.env.REACT_APP_) !== null && _process$env$REACT_AP2 !== void 0 ? _process$env$REACT_AP2 : 'false');
        return isApprovedEmail && isApiEnabled;
    };
    // Handle email validation and search
    var handleEmailSearch = /*#__PURE__*/ function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2(userIndex) {
            var userEmail, isEmailLike, validationResult, _validationResult$use, _parseUserName, firstName, lastName;
            return _regenerator().w(function (_context2) {
                while (1)
                    switch (_context2.n) {
                        case 0:
                            userEmail = users[userIndex].email.trim();
                            if (userEmail) {
                                _context2.n = 1;
                                break;
                            }
                            setUsers(function (prev) {
                                return prev.map(function (user, index) {
                                    return index === userIndex ? _objectSpread(_objectSpread({}, user), {}, {
                                        emailValidationError: null
                                    }) : user;
                                });
                            });
                            return _context2.a(2);
                        case 1:
                            // Check if it looks like an email (contains @ and at least basic format)
                            isEmailLike = userEmail.includes('@') && userEmail.length > 3;
                            if (!isEmailLike) {
                                _context2.n = 5;
                                break;
                            }
                            if (!shouldValidateViaAPI(userEmail)) {
                                _context2.n = 3;
                                break;
                            }
                            _context2.n = 2;
                            return validateEmailWithAPI(userEmail, userIndex);
                        case 2:
                            validationResult = _context2.v;
                            if (validationResult.isValid && validationResult.userInfo) {
                                // Parse name from API response
                                _parseUserName = parseUserName((_validationResult$use = validationResult.userInfo.name) !== null && _validationResult$use !== void 0 ? _validationResult$use : ''), firstName = _parseUserName.firstName, lastName = _parseUserName.lastName; // Auto-populate form fields with validated user data
                                setUsers(function (prev) {
                                    return prev.map(function (user, index) {
                                        return index === userIndex ? _objectSpread(_objectSpread({}, user), {}, {
                                            firstName: firstName,
                                            lastName: lastName,
                                            namesFromAPI: true,
                                            emailValidationError: null
                                        }) : user;
                                    });
                                });
                            }
                            else {
                                setUsers(function (prev) {
                                    return prev.map(function (user, index) {
                                        return index === userIndex ? _objectSpread(_objectSpread({}, user), {}, {
                                            emailValidationError: validationResult.error || constants.add_user_modal_email_invalid,
                                            namesFromAPI: false
                                        }) : user;
                                    });
                                });
                            }
                            _context2.n = 4;
                            break;
                        case 3:
                            // For non-Deloitte emails, just clear any previous results and errors
                            // Don't call API, allow manual entry
                            setUsers(function (prev) {
                                return prev.map(function (user, index) {
                                    return index === userIndex ? _objectSpread(_objectSpread({}, user), {}, {
                                        emailValidationError: null,
                                        namesFromAPI: false
                                    }) : user;
                                });
                            });
                        case 4:
                            _context2.n = 6;
                            break;
                        case 5:
                            // Clear search results when query is empty
                            setUsers(function (prev) {
                                return prev.map(function (user, index) {
                                    return index === userIndex ? _objectSpread(_objectSpread({}, user), {}, {
                                        emailValidationError: null,
                                        namesFromAPI: false
                                    }) : user;
                                });
                            });
                        case 6:
                            return _context2.a(2);
                    }
            }, _callee2);
        }));
        return function handleEmailSearch(_x3) {
            return _ref3.apply(this, arguments);
        };
    }();
    // Helper function to get button text
    var getButtonText = function getButtonText() {
        if (loading) {
            return user ? constants.configuration_modal_button_updating : constants.configuration_modal_button_adding;
        }
        return user ? constants.configuration_modal_button_update : constants.configuration_modal_button_add;
    };
    // Add a new user form
    var addUser = function addUser() {
        setUsers(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
                    id: Date.now(),
                    email: '',
                    firstName: '',
                    lastName: '',
                    phoneNumber: '',
                    namesFromAPI: false,
                    isValidatingEmail: false,
                    emailValidationError: null
                }]);
        });
    };
    // Remove a user form
    var removeUser = function removeUser(userIndex) {
        if (users.length > 1) {
            setUsers(function (prev) {
                return prev.filter(function (_, index) {
                    return index !== userIndex;
                });
            });
        }
    };
    // Clear email validation for a user
    var clearEmailValidation = useCallback(function (userIndex) {
        clearEmailValidationHelper(userIndex, setUsers);
    }, []);
    // Update user field
    var updateUserField = function updateUserField(userIndex, field, value) {
        setUsers(function (prev) {
            return prev.map(function (user, index) {
                return index === userIndex ? _objectSpread(_objectSpread({}, user), {}, _defineProperty({}, field, value), field === 'email' && user.namesFromAPI ? {
                    namesFromAPI: false
                } : {}) : user;
            });
        });
    };
    var handleSave = function handleSave() {
        var usersData = users.map(function (u) {
            return {
                id: u.id.toString(),
                name: "".concat(u.firstName, " ").concat(u.lastName).trim(),
                email: u.email,
                phone: u.phoneNumber,
                role: '',
                avatarUrl: ''
            };
        });
        // Delegate to parent for both create and update
        onSave(usersData);
    };
    var canAdd = users.every(function (user) {
        return user.email && user.firstName && user.lastName;
    });
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose,
        maxWidth: "sm",
        fullWidth: true,
        sx: {
            '& .MuiDialog-paper': {
                borderRadius: 2,
                boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.12)',
                minHeight: 400
            }
        }
    }, /*#__PURE__*/ React.createElement(DialogTitle, {
        variant: "h6",
        "data-testid": "modal-title",
        sx: {
            color: '#212121',
            borderBottom: '1px solid #ebebeb',
            fontFamily: 'Open Sans',
            fontWeight: 600,
            fontSize: 20,
            px: 3,
            py: 3
        }
    }, user ? constants.edit_user_modal_title : constants.add_user_modal_title), saveError && /*#__PURE__*/ React.createElement(Alert, {
        severity: "error",
        sx: {
            mx: 3,
            mt: 2,
            fontFamily: 'Open Sans'
        }
    }, saveError), /*#__PURE__*/ React.createElement(DialogContent, {
        sx: {
            p: '24px !important'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        }
    }, users.map(function (currentUser, userIndex) {
        return /*#__PURE__*/ React.createElement(Box, {
            key: currentUser.id,
            sx: _objectSpread({
                position: 'relative',
                border: '1px solid #d9d9d9',
                borderRadius: '8px',
                p: 2,
                pr: users.length > 1 ? 5 : 2
            }, userIndex > 0 && {
                mt: 3
            })
        }, users.length > 1 && /*#__PURE__*/ React.createElement(Box, {
            sx: {
                position: 'absolute',
                top: 12,
                right: 12,
                cursor: 'pointer',
                zIndex: 10,
                backgroundColor: 'white',
                borderRadius: '50%',
                width: 28,
                height: 28,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                '&:hover': {
                    backgroundColor: '#f5f5f5'
                }
            },
            onClick: function onClick() {
                return removeUser(userIndex);
            }
        }, /*#__PURE__*/ React.createElement(DeleteIcon, {
            sx: {
                color: '#d32f2f',
                fontSize: 18
            }
        })), /*#__PURE__*/ React.createElement(Box, {
            sx: {
                mb: 2,
                position: 'relative'
            }
        }, /*#__PURE__*/ React.createElement(TextField, {
            fullWidth: true,
            size: "small",
            label: constants.add_user_modal_email,
            placeholder: constants.add_user_modal_email,
            required: true,
            disabled: !!user,
            value: currentUser.email,
            onChange: function onChange(e) {
                var newEmail = e.target.value;
                updateUserField(userIndex, 'email', newEmail);
            },
            onBlur: function onBlur(e) {
                e.preventDefault();
                e.stopPropagation();
                handleEmailSearch(userIndex);
            },
            error: !!currentUser.emailValidationError,
            helperText: currentUser.emailValidationError,
            slotProps: {
                input: {
                    endAdornment: getEmailEndAdornment(currentUser, userIndex, updateUserField, clearEmailValidation)
                },
                inputLabel: {
                    sx: {
                        '& .MuiInputLabel-asterisk': {
                            color: '#d32f2f'
                        }
                    }
                }
            }
        })), /*#__PURE__*/ React.createElement(Box, {
            sx: {
                display: 'flex',
                gap: 2,
                mb: 2
            }
        }, /*#__PURE__*/ React.createElement(TextField, {
            fullWidth: true,
            size: "small",
            label: constants.add_user_modal_first_name,
            placeholder: constants.add_user_modal_first_name,
            required: true,
            disabled: currentUser.namesFromAPI,
            value: currentUser.firstName,
            onChange: function onChange(e) {
                return updateUserField(userIndex, 'firstName', e.target.value);
            },
            InputLabelProps: {
                sx: {
                    '& .MuiInputLabel-asterisk': {
                        color: '#d32f2f'
                    }
                }
            }
        }), /*#__PURE__*/ React.createElement(TextField, {
            fullWidth: true,
            size: "small",
            label: constants.add_user_modal_last_name,
            placeholder: constants.add_user_modal_last_name,
            required: true,
            disabled: currentUser.namesFromAPI,
            value: currentUser.lastName,
            onChange: function onChange(e) {
                return updateUserField(userIndex, 'lastName', e.target.value);
            },
            InputLabelProps: {
                sx: {
                    '& .MuiInputLabel-asterisk': {
                        color: '#d32f2f'
                    }
                }
            }
        })), /*#__PURE__*/ React.createElement(TextField, {
            fullWidth: true,
            size: "small",
            label: constants.add_user_modal_phone_number,
            placeholder: constants.add_user_modal_phone_number,
            value: currentUser.phoneNumber,
            onChange: function onChange(e) {
                return updateUserField(userIndex, 'phoneNumber', e.target.value);
            }
        }));
    }), /*#__PURE__*/ React.createElement(Box, {
        onClick: addUser,
        sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            mt: 2,
            cursor: 'pointer'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            width: 20,
            height: 20,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }
    }, /*#__PURE__*/ React.createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M10 3.33334V16.6667M3.33334 10H16.6667",
        stroke: "#26890D",
        strokeWidth: "1.66667",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }))), /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontFamily: 'Open Sans',
            fontSize: 14,
            color: '#26890d',
            fontWeight: 600
        }
    }, constants.add_user_modal_add_another_member)))), /*#__PURE__*/ React.createElement(DialogActions, {
        sx: {
            p: '24px !important',
            gap: 2,
            borderTop: '1px solid #ebebeb'
        }
    }, /*#__PURE__*/ React.createElement(Button, {
        fullWidth: true,
        variant: "outlined",
        onClick: onClose,
        disabled: loading,
        sx: {
            borderColor: '#26890d',
            color: '#26890d',
            textTransform: 'none',
            fontFamily: 'Open Sans',
            fontWeight: 600,
            fontSize: 16,
            px: 2,
            py: 1,
            '&:hover': {
                borderColor: '#26890d',
                backgroundColor: 'rgba(38, 137, 13, 0.04)'
            }
        }
    }, constants.cancel), /*#__PURE__*/ React.createElement(Button, {
        fullWidth: true,
        onClick: handleSave,
        variant: "contained",
        disabled: loading || !canAdd,
        sx: {
            backgroundColor: canAdd ? '#26890d' : '#cccccc',
            color: '#ffffff',
            textTransform: 'none',
            fontFamily: 'Open Sans',
            fontWeight: 600,
            fontSize: 16,
            px: 3,
            py: 1,
            '&:hover': {
                backgroundColor: canAdd ? '#1f6b0a' : '#cccccc'
            },
            '&:disabled': {
                backgroundColor: '#cccccc',
                color: '#ffffff'
            }
        }
    }, getButtonText())));
};
export default AddUserModal;
